var map = {
	"./pump-blue.png": "a80a",
	"./pump-false.png": "21e9",
	"./pump-gray.png": "4d30",
	"./pump-green.png": "cebb",
	"./pump-offline.png": "801a",
	"./pump-red.png": "dac0",
	"./pump-true.png": "ba90",
	"./pump-undefined.png": "ca24",
	"./pump-yellow.png": "9df5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0ba2";